export default __webpack_public_path__ + "static/new-survey-dark-mode-35bf9afb2ffe72a8521a0e548c096819.png";